export default "__VITE_PUBLIC_ASSET__136cd498__"